export function createResource(type) {
    return {
        resourceType: type,
    };
}
